import { InstantGameInterface } from "./InstantGameInterface.mjs";
import { NativeBuilderInterface } from "./NativeBuilderInterface.mjs";
function createLegacyNativeInterface() {
  return InstantGameInterface.create() ?? NativeBuilderInterface.create();
}
export {
  createLegacyNativeInterface
};
